<div class="bottom-nav">
  <div
    class="nav-item"
    *ngFor="let item of navItems"
    [routerLink]="item.route"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: item.exact ?? false }">
        <div class="svg-div" [ngClass]="{'svg-active': isActive(item.route)}">
            <img [src]="'../../../mobile/assets/' + (isActive(item.route) ? item.svg : item.inActiveSvg) + '.svg'" [alt]="item.svg" />
        </div>
        <span class="title">{{ item.label }}</span>
  </div>
</div>